import styled from "styled-components";

export const MessageDisplayDiv = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  height: 100%;
  width: 100%;
  display: flex;
  .file-selected {
    background-color: #F0F0FF;
    height: calc(100% - 65px);
    justify-content: center;
    justify-items: center;
    .header {
      display: flex;
      justify-content: space-between;
      padding: 20px;
      width: 100%;
      box-sizing: border-box;
      &__close {
        background-color: #3E3DA3;
        width: 40px;
        height: 40px;
        border-radius: 27.5px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
      }
      &__info {
        display: flex;
      }
      &__img {
        margin-right: 10px;
      }
      &__text {
        color: #68688D;
        align-items: center;
      }
    }
  }
  .error-reaction {
    display: flex;
    justify-content: center;
    height: calc(100% - 85px);
  }
  .file {
    margin-top: 60px;
    border-radius: 14px;
    width: 80%;
    height: 80%;
    overflow: hidden;
    .file__preview {
      /* width: 100%;
      height: 100%; */
      height: calc(100% - 63px);
      background-color: #FFF;
      color: #707582;
      display: flex;
    }
    .file__icon {
      margin: auto;
      font-size: 172px;
    }
    .file__img {
      width: 100%;
      height: 100%;
      border: 2px solid #FFFFFF7D;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .file__title {
      padding: 16px 10px;
      color: #1F1F52;
      font-size: 17px;
      background-color: #F2F2F7;
      border-bottom: 8px solid #FFFFFF7D;
      border-right: 8px solid #FFFFFF7D;
      border-left: 8px solid #FFFFFF7D;
    }
  }
  .messageDisplay__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 40px;
    border-bottom: 1px solid #f3f3f3;
    box-sizing: border-box;
    .messageDisplay__headerBack{
      margin-right: 10px;
      display: none;
      font-size: 22px;
      i {
        display: flex;
      }
    }
    .messageDisplay__headerName {
      display: flex;
      width: 100%;
      align-items: center;
      position: relative;
      .oneSingleChat__imgContainer{
        position: relative;
        .oneSingleChat__online {
          background-color: ${(props) => props.online ? "var(--green-color)" : "var(--red-color)"};
          height: 12px;
          width: 12px;
          border-radius: 50%;
          position: absolute;
          right: 3px;
          top: -4px;
          border: 2px solid var(--white);
        }
      }
      /* img {
        width: 56px;
        height: 56px;
        border-radius: 10px;
        margin-right: 8px;
        object-fit: cover;
      } */
      h4 {
        color: #1F1F52;
        font-family: Nunito Sans Light;
        font-size: 18px;
        margin-left: 10px;
      }
    }
    .icon-container {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      background-color: #2E2CBF;
      justify-content: center;
    }
    .zaia-icono-dots-horizontal {
      font-size: 17px;
      cursor: pointer;
      color: var(--white);
      display: flex;
      margin: auto;
    }
  }
  /* .messageDisplay__containerDate {
    color: var(--subtitle-color);
    font-size: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .messageDisplay__containerMsgs {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    height: 100%;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    .messageDisplay__containerMsg {
      margin-left: 10px;
      font-size: xx-small;
      .chat__reciever {
        display: flex;
        flex-direction: column;
        margin-bottom: 30px;
        p {
          font-size: 0.88rem;
          padding: 10px;
          border-radius: 10px 10px 0 10px;
          width: fit-content;
          background-color: var(--blue-color);
          color: var(--white);
          margin-left: auto;
          font-family: "Nunito";
        }
        small {
          margin-left: auto;
          color: var(--subtitle-color);
        }
      }
      .chat__patient {
        display: flex;
        flex-direction: column;
        margin-bottom: 30px;
        p {
          background-color: var(--footer-color);
          font-size: 0.88rem;
          padding: 10px;
          border-radius: 10px 10px 10px 0;
          width: fit-content;
          font-family: "Nunito";
        }
        small {
          color: var(--subtitle-color);
        }
      }
    }
  }
  .messageDisplay__containerFooter {
    background-color: var(--footer-color);
    padding: 15px;
    display: flex;
    color: var(--blue-color);
    align-items: center;
    justify-content: space-evenly;
    p {
      font-size: 2rem;
    }
    input {
      border: none;
      border-radius: 20px;
      padding: 10px;
      width: 540px;
      margin: 0 5px 0 5px;
      &:focus {
        outline: none;
      }
      ::placeholder {
        color: #e3e3e3;
      }
    } 
  }*/
  .rightside__container-msgs {
    display: flex;
    height: -webkit-fill-available;
    overflow-y: scroll;
    background-color: #F0F0FF;
    &::-webkit-scrollbar {
      display: none;
    }
    .rightside__msgs {
      padding: 10px 70px 0 90px;
      /* padding-top: 10px; */
      width: 100%;
      display: flex;
      flex-direction: column-reverse;
      overflow-y: scroll;
      &::-webkit-scrollbar-track {
        border: solid 10px transparent;
        box-shadow: inset 0 0 10px 10px transparent;      
      }
    }
  }
  .messageDisplay__containerFooter {
    background-color: #FFFFFF;
    padding: 10px 90px;
    display: flex;
    color: var(--blue-color);
    align-items: center;
    justify-content: space-evenly;
    input {
      background-color: #F0F0FF;
      border: none;
      border-radius: 75px;
      padding: 13px 20px;
      width: 85%;
      margin: 0 5px 0 5px;
      outline: none;
      font-family: "Nunito Sans";
      font-size: 16px;
      color: #1F1F52;
      ::placeholder {
        color: #e3e3e3;
        font-family: "Nunito Sans";
      }
    }
    button {
      background-color: #2E2CBF;
      color: var(--blue-color);
      border: none;
      cursor: pointer;  
      display: flex;
      margin: 0 10px;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      align-items: center;
      justify-content: center;

      .send-icon{
        color: var(--white);
        font-size: 12px;
        margin-bottom: -6px;
        margin: auto;
        display: flex;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .messageDisplay__headerBack {
      display: block !important;
    }
  }
`;

export const ChatSettings = styled.div`
  position: relative;
  background-color: var(--white);
  height: auto;
  width: 160px;
  overflow-y: auto;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
  text-align: center;
  &::-webkit-scrollbar{
    display: none;
  }
  .chat-setting-box {
    font-family: "Nunito";
    font-size: 15px;
    color: var(--blue-color) !important;
    display: flex;
    padding: 10px 0;
    justify-content: center;
    cursor: pointer;
    .icono-settings {
      font-size: 20px;
      margin-right: 10px;
      margin-bottom: -6px;
    }
  }
`

export const MessagesTypes = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #EFEFF6F2;
  height: auto;
  overflow-y: auto;
  border-radius: 20px;
  box-shadow: 0px 3px 6px #00000029;
  text-align: center;
  padding: 20px;
  border: 2px solid #FFFFFF;
  &::-webkit-scrollbar{
    display: none;
  }
  .chat-setting-box {
    min-width: 300px;
    font-family: "Nunito";
    font-size: 15px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    cursor: pointer;
    &__text {
      font-size: 20px;
      font-family: "Nunito Sans";
      color: #1F1F52;
    }
    .icono-settings {
      font-size: 20px;
      display: flex;
      color: #3E3E5B;
    }
  }
`
